<template>
  <div class="appointment-item">
    <div class="order-card">
      <!-- 标题区域 -->
      <div class="order-header">
        <div class="order-number">
          <span>预约编号: {{appointmentItem.appointmentNo}}</span>
        </div>
        <div class="order-status">
          <van-tag mark :type="appointmentItem.bpmStatusType" size="medium" plain>{{appointmentItem.bpmStatusTitle}}</van-tag>
        </div>
      </div>
      
      <!-- 内容区域 -->
      <div class="order-info" @click="jumpAppointmentDetail(appointmentItem.id)">
        <div class="info-item">
          <span class="info-label"><van-icon name="manager-o" /> 司机姓名:</span>
          <span class="info-value">{{appointmentItem.driverName}}</span>
        </div>
        <div class="info-item">
          <span class="info-label"><van-icon name="guide-o" /> 车头号:</span>
          <span class="info-value">{{appointmentItem.headstock}}</span>
        </div>
        <div class="info-item">
          <span class="info-label"><van-icon name="cluster-o" /> 车挂号:</span>
          <span class="info-value">{{appointmentItem.handnum}}</span>
        </div>
        <div class="info-item">
          <span class="info-label"><van-icon name="goods-collect-o" /> 上一载重品种:</span>
          <span class="info-value">{{appointmentItem.variety}}</span>
        </div>
        <div class="info-item" v-if="appointmentItem.cargoHoldsNumbs">
          <span class="info-label"><van-icon name="volume-o" /> 货舱数:</span>
          <span class="info-value">{{appointmentItem.cargoHoldsNumbs}}</span>
        </div>
        <div class="info-item">
          <span class="info-label"><van-icon name="shield-o" /> 罐体材质:</span>
          <span class="info-value">{{appointmentItem.tankMaterial}}</span>
        </div>
        <div class="info-item">
          <span class="info-label"><van-icon name="calendar-o" /> 预约日期:</span>
          <span class="info-value">{{appointmentItem.appointmentTime}}</span>
        </div>
        <div class="info-item">
          <span class="info-label"><van-icon name="clock-o" /> 预约时间:</span>
          <span class="info-value">{{appointmentItem.appointmentPdxx}}</span>
        </div>
        <!-- <div class="info-item">
          <span class="info-label"><van-icon name="location-o" /> 蒸洗口:</span>
          <span class="info-value">{{appointmentItem.steamPort}}</span>
        </div> -->
        <div class="info-item" v-if="appointmentItem.payMethod == '1'">
          <span class="info-label"><van-icon name="balance-o" /> 支付方式:</span>
          <span class="info-value">对公账户支付</span>
        </div>
        <div class="info-item" v-if="appointmentItem.payMethod == '2'">
          <span class="info-label"><van-icon name="paid" /> 支付方式:</span>
          <span class="info-value">个人支付</span>
        </div>
      </div>
      
      <!-- 底部按钮区域 -->
      <div class="order-actions">
        <van-button 
          type="info" 
          size="small" 
          class="action-btn" 
          @click="jumpAppointmentDetail(appointmentItem.id)"
        >
          预约详情
        </van-button>
        
        <van-button 
          v-if="appointmentItem.bpmStatus == '2'" 
          type="primary" 
          size="small" 
          class="action-btn" 
          @click="payAppointment(appointmentItem.id)"
        >
          去支付
        </van-button>
        
        <van-button 
          v-if="isShowCancel" 
          type="default" 
          size="small" 
          class="action-btn cancel-btn" 
          @click="cancelAppointment(appointmentItem.id)"
        >
          取消预约
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    appointmentItem:{
      type:Object,
      required: true
    }
  },
  computed:{
    isShowCancel()
    {
      return this.appointmentItem.bpmStatus <11;
    },
  },
  methods:{
    jumpAppointmentDetail(id)
    {
      this.$router.push({
        name: 'steamAppointmentInfo',
        params:{
          id:id
        }
      })
    },
    cancelAppointment(id)
    {
      this.$emit("cancelAppointmentP",id);
    },
    payAppointment(appointmentId)
    {
      this.$emit('goSteamWechatPay',appointmentId)
    },

  },
}
</script>

<style lang="scss" scoped>
.appointment-item {
  margin-bottom: 12px;
}

.order-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  .order-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f5f6f7;
    
    .order-number {
      font-size: 14px;
      font-weight: 500;
      color: #323233;
    }
  }
  
  .order-info {
    padding: 12px 16px;
    
    .info-item {
      display: flex;
      margin-bottom: 8px;
      align-items: flex-start;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .info-label {
        width: 110px;
        font-size: 14px;
        color: #969799;
        display: flex;
        align-items: center;
        
        .van-icon {
          margin-right: 4px;
          font-size: 16px;
          color: #4080ff;
        }
      }
      
      .info-value {
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        color: #323233;
      }
    }
  }
  
  .order-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding: 12px 16px;
    border-top: 1px solid #f5f6f7;
    
    .action-btn {
      margin-left: 8px;
      margin-bottom: 8px;
      border-radius: 4px;
      
      &.cancel-btn {
        background-color: #f7f8fa;
        color: #323233;
        border: 1px solid #e8e8e8;
      }
    }
  }
}
</style>
